import { Link as RouterLink } from 'react-router-dom';
import moment  from 'moment';
// @mui
import { Box, Grid, Link, Stack, Divider, Container, Typography, IconButton } from '@mui/material';
// routes
import { PATH_PAGE } from '../../routes/paths';
// _mock
import { SOCAL_NETWORK } from '../../_mock/socialNetwork';
// components
import Logo from '../../components/logo';
import Iconify from '../../components/iconify';
// locales
import { useLocales } from '../../locales';

export default function Footer() {
  const { translate } = useLocales();
  const ACTUAL_YEAR = moment().format('YYYY');

  const LINKS = [
    {
      headline: translate('FOOTER.LINKS.ITEM_1.TITLE'),
      children: [
        { name: translate('FOOTER.LINKS.ITEM_1.LINK_1'), href: PATH_PAGE.about },
        { name: translate('FOOTER.LINKS.ITEM_1.LINK_2'), href: PATH_PAGE.contact },
        { name: translate('FOOTER.LINKS.ITEM_1.LINK_3'), href: PATH_PAGE.agroLabStamp },
      ],
    },
    {
      headline: translate('FOOTER.LINKS.ITEM_2.TITLE'),
      children: [
        { name: translate('FOOTER.LINKS.ITEM_2.LINK_1'), href: '#' },
        { name: translate('FOOTER.LINKS.ITEM_2.LINK_2'), href: '#' },
      ],
    },
    {
      headline: translate('FOOTER.LINKS.ITEM_3.TITLE'),
      children: [
        { name: translate('FOOTER.LINKS.ITEM_3.LINK_1'), href: '#' },
        { name: translate('FOOTER.LINKS.ITEM_3.LINK_2'), href: '#' },
      ],
    },
  ];

  const mainFooter = (
    <Box
      component="footer"
      sx={{
        position: 'relative',
        bgcolor: 'background.default',
      }}
    >
      <Divider />

      <Container sx={{ pt: 10 }}>
        <Grid
          container
          justifyContent={{
            xs: 'center',
            md: 'space-between',
          }}
          sx={{
            textAlign: {
              xs: 'center',
              md: 'left',
            },
          }}
        >
          <Grid item xs={12} sx={{ mb: 3 }}>
            <Logo sx={{ mx: { xs: 'auto', md: 'inherit' } }} />
          </Grid>

          <Grid item xs={8} md={3}>
            <Typography variant="body2" sx={{ pr: { md: 5 } }}>
            {translate('HOME.HERO.SUBTITLE')}
            </Typography>

            <Stack
              spacing={1}
              direction="row"
              justifyContent={{ xs: 'center', md: 'flex-start' }}
              sx={{
                mt: 5,
                mb: { xs: 5, md: 0 },
              }}
            >
              {SOCAL_NETWORK.map((social) => (
                <Link
                key={social.name}
                href={social.path}
                target="_blank"
                rel="noopener noreferrer"
                color="inherit"
                variant="body2"
              >
                <IconButton key={social.name}>
                  <Iconify icon={social.icon} color={social.color} />
                </IconButton>
              </Link>
              ))}
            </Stack>
          </Grid>

          <Grid item xs={12} md={7}>
            <Stack
              spacing={5}
              justifyContent="space-between"
              direction={{ xs: 'column', md: 'row' }}
            >
              {LINKS.map((list) => (
                <Stack
                  key={list.headline}
                  spacing={2}
                  alignItems={{ xs: 'center', md: 'flex-start' }}
                >
                  <Typography component="div" variant="overline">
                    {list.headline}
                  </Typography>

                  {list.children.map((link) => (
                    <Link
                      key={link.name}
                      to={link.href}
                      component={RouterLink}
                      color="inherit"
                      variant="body2"
                    >
                      {link.name}
                    </Link>
                  ))}
                </Stack>
              ))}
            </Stack>
          </Grid>
        </Grid>

        <Typography
          variant="caption"
          component="div"
          sx={{
            mt: 10,
            pb: 5,
            textAlign: { xs: 'center', md: 'left' },
          }}
        >
          © {ACTUAL_YEAR}. {translate('FOOTER.RIGHT_RESERVED')}
        </Typography>
      </Container>
    </Box>
  );

  return  mainFooter;
}
